var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17L18.844 15.132C18.7727 15.0645 18.6832 15.0194 18.5864 15.0024C18.4897 14.9854 18.3901 14.9973 18.3001 15.0365C18.2101 15.0758 18.1337 15.1407 18.0803 15.2231C18.0269 15.3055 17.999 15.4018 18 15.5V16C18 16.2652 17.8946 16.5196 17.7071 16.7071C17.5196 16.8947 17.2652 17 17 17H15C14.7348 17 14.4804 16.8947 14.2929 16.7071C14.1054 16.5196 14 16.2652 14 16C14 13.455 10.009 12.03 5.5 12C4.83696 12 4.20107 12.2634 3.73223 12.7322C3.26339 13.2011 3 13.837 3 14.5C3 15.1631 3.26339 15.7989 3.73223 16.2678C4.20107 16.7366 4.83696 17 5.5 17C9.653 17 10.245 5.70502 11.208 3.50002C11.3707 3.12781 11.6216 2.80085 11.9391 2.54743C12.2565 2.294 12.6309 2.12175 13.0299 2.04557C13.4289 1.9694 13.8405 1.99159 14.229 2.11024C14.6175 2.22888 14.9712 2.4404 15.2595 2.7265C15.5479 3.01259 15.7622 3.36464 15.8839 3.75218C16.0056 4.13973 16.0311 4.55109 15.958 4.95067C15.885 5.35026 15.7157 5.72603 15.4648 6.04547C15.2139 6.36492 14.8889 6.61841 14.518 6.78402",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H21",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.578ffff01c420cab949420651291f854.svg";
export { ForwardRef as ReactComponent };